// Utility function to format date without timezone issues
export const formatDateToString = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// Utility function to parse date string without timezone issues
export const parseDateString = (dateStr) => {
  if (!dateStr) return null;
  const [year, month, day] = dateStr.split('-').map(Number);
  return new Date(year, month - 1, day); // month is 0-indexed
};

// Test function to verify date formatting
export const testDateFormatting = () => {
  console.log('🧪 Testing date formatting...');
  
  // Test case 1: January 3rd, 2025
  const testDate1 = new Date(2025, 0, 3); // January 3rd (month is 0-indexed)
  const formatted1 = formatDateToString(testDate1);
  console.log(`Date: ${testDate1.toDateString()} -> Formatted: ${formatted1}`);
  console.log(`Expected: 2025-01-03, Got: ${formatted1}, Match: ${formatted1 === '2025-01-03'}`);
  
  // Test case 2: January 5th, 2025
  const testDate2 = new Date(2025, 0, 5); // January 5th
  const formatted2 = formatDateToString(testDate2);
  console.log(`Date: ${testDate2.toDateString()} -> Formatted: ${formatted2}`);
  console.log(`Expected: 2025-01-05, Got: ${formatted2}, Match: ${formatted2 === '2025-01-05'}`);
  
  // Test case 3: Parse back the formatted date
  const parsed1 = parseDateString(formatted1);
  console.log(`Parsed back: ${parsed1.toDateString()}`);
  console.log(`Original: ${testDate1.toDateString()}, Parsed: ${parsed1.toDateString()}, Match: ${testDate1.toDateString() === parsed1.toDateString()}`);
  
  console.log('✅ Date formatting test completed');
};

// Call test in development
if (process.env.NODE_ENV === 'development') {
  testDateFormatting();
}